import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { runCropTma } from 'api/platform';
import { enqueueSnackbar } from 'notistack';
import React, { FunctionComponent, useState } from 'react';
import { CasesParams } from 'utils/useCasesParams/types';
import { useMutationWithErrorSnackbar } from 'utils/useMutationWithErrorSnackbar';

export interface RunCropTmaProps {
  onClose: (event?: any, force?: boolean) => void;
  casesParams: CasesParams;
  detectTmaJobId?: string;
  platformVersionWarning?: React.ReactNode;
}

const RunCropTma: FunctionComponent<RunCropTmaProps> = ({
  casesParams,
  detectTmaJobId,
  onClose,
  platformVersionWarning,
}) => {
  const [open, setOpen] = useState(true);

  const cropTmaMutation = useMutationWithErrorSnackbar({
    mutationFn: runCropTma,
    mutationDescription: 'initiate crop TMA task',
    onSuccess: (data: any) => {
      enqueueSnackbar(data?.message || 'Crop TMA task started successfully', { variant: 'success' });
    },
  });

  const handleClose = () => {
    setOpen(false);
    onClose(undefined, true);
  };

  const handleExecute = () => {
    cropTmaMutation.mutate({ ...casesParams, detectTmaJobId });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Confirm Action</DialogTitle>
      <DialogContent>
        {platformVersionWarning}
        <Typography>Are you sure you want to execute the Crop TMA task on selected cases/slides?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleExecute} color="primary" variant="contained">
          Execute
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RunCropTma;
